$(() => {
 
  var slideIndex = 1;

  $(".js-open-modal-image").on({
    click: (e) => {
      document.getElementById("myModal"+e.currentTarget.dataset.uid).style.display = "block";
    }
  });
  
  $(".js-open-modal-gallery-image").on({
    click: (e) => {
     let si = e.currentTarget.closest('.js-current-slide').dataset.currentslide
     slideIndex = si
     let contentid = e.currentTarget.dataset.uid
     let modalid = e.currentTarget.closest('.bwgallery').dataset.modalid
    document.getElementById("bwModal"+modalid).style.display = "block";
    }
  });

  $(".js-close-modal").on('click', function (e) {
    $(this).parent().hide()
  });

  const showSlides = (n) => {
    var i;
    var slides = document.getElementsByClassName("bwSlides");
    var dots = document.getElementsByClassName("demo");
    var captionText = document.getElementById("caption");
    if (n > slides.length) {slideIndex = 1}
    if (n < 1) {slideIndex = slides.length}
    for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
    }
    for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
    }
    slides[slideIndex-1].style.display = "block";
    dots[slideIndex-1].className += " active";
    captionText.innerHTML = dots[slideIndex-1].alt;
  }  

  $(".js-next-pic").on({
    click: (e) => {
      slideIndex++
      showSlides(slideIndex);
    }
  });  

  $(".js-prev-pic").on({
    click: (e) => {
      slideIndex--
      showSlides(slideIndex);
    }
  });  

  $(".js-current-slide").on({
    click: (e) => {
    slideIndex = e.currentTarget.dataset.currentslide
    showSlides(slideIndex);
    }
  }); 

  var move = 0

  $(".js-thumbnail-slide-next").on({
    click: (e) => {
      var cWidth = document.documentElement.clientWidth;
      var displayedElements = 6

      if (cWidth < 768) { displayedElements = 2}
      if ((cWidth >= 768) && ( 810 > cWidth)) {displayedElements = 3}
      if ((cWidth >= 810) && ( 992 > cWidth)) {displayedElements = 4}
      if ((cWidth >= 992) && (1200 > cWidth)) {displayedElements = 5}
      if (cWidth >= 1200) {displayedElements = 6}

      var numberOfSlideElements = document.querySelector(".thumbnail-container").childElementCount
      var thumbnailContainerWidth = $('.thumbnail-container').width()
    
      if (move > ('-'+(numberOfSlideElements-displayedElements)*100)) { 
        move -= 100 
        slideMovement(move)
      }
    }
  }); 

  $(".js-thumbnail-slide-prev").on({
    click: (e) => {
      if (move < 0) {
        move += 100 
        slideMovement(move)
        
      }
    }
  }); 

  const slideMovement = (move) => {
    $(".thumbnail-container .column").css('transform', 'translateX('+ move +'%');
  }
})


